// ============================================================================
// view.cattlelog — migrated off the global-read parity claim
// ============================================================================
// Cattle Log owns three distinct render reads: its keyset-paginated entry RPC,
// its active-cattle tag/calf preview, and its role-filtered mention picker.
// Each is scoped by the catalog under the authenticated QueryScope. The page
// remains boot-dependent until Foundation B replaces App's all-data boundary;
// this declaration makes no boot-independence claim.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'view.cattlelog',
  obligations: Object.freeze([
    Object.freeze({id: 'cattle.log.page', owner: 'permanent'}),
    Object.freeze({id: 'cattle.log.cattle.preview', owner: 'permanent'}),
    Object.freeze({id: 'cattle.log.mentionable.profiles', owner: 'permanent'}),
  ]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
